
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Table, Column, StringHelper, useScreenDimension } from "@rivtn/noseur";
import { ITournamentTransaction, EarningService, TransactionType, ITournamentEdition, ApiResponseData, TournamentService, BaseService, SanitizedResponse, TransactionStatus } from "../../../../../../services";
import { Schemes, Utils } from "../../../../../../utils";
import { Elements } from "../../../../../shared/Elements";
import { i18nManager } from "../../../../../../i18n";

interface RecentTransactionsProps {
    tournamentEdition: ITournamentEdition;
    hideDescription?: boolean;
}

function RecentTransactions(props: RecentTransactionsProps) {

    const { width } = useScreenDimension();
    const { tournamentEdition, hideDescription } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.finance;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [recentTransactions, setRecentTransactions] = React.useState<ApiResponseData<ITournamentTransaction>>({});

    React.useEffect(fetchInformation, []);

    return (<>
        <div className="rtrans-header" style={{ display: "flex", margin: "10px 0px 20px 0px", justifyContent: "space-between" }}>
            <span className="l">{labels.recent_trans}</span>
            <ReactRouterDom.NavLink to={`/hosts/${tournamentEdition.tournament.host.public_id}/tournament/${tournamentEdition.tournament.external_id}/finance/transactions`}>{labels.view_all}</ReactRouterDom.NavLink>
        </div>
        <Table scheme={Schemes.OMNEHOST} data={recentTransactions.content} totalRecords={recentTransactions.total_elements} dataRefreshKeys={["external_id", "created_at"]}
            style={{ flex: 1 }} rowsPerPage={200} loadingState={Elements.LOADING_STATE} emptyState={Elements.buildEmptyListView("fa fa-coins", labels.table.empty_label_parts.no_trans, { marginTop: 70 })}>
            <Column className="table-c" header={labels.table.headers.date} dataKey="created_at" template={(v) => Utils.formatToFineDate(v, true)} />
            <Column className="table-c" header={labels.table.headers.source} dataKey="source" template={(v: string) => Utils.toSaneSentenceFormat(v).split(" ").slice(1).join(" ").replaceAll("Currency Balance", "").trim()} />
            <Column className="table-c" doNotRender={hideDescription || width < 800} header={labels.table.headers.description} dataKey="description" />
            <Column className="table-c" header={labels.table.headers.amount} template={(v: ITournamentTransaction) => {
                const isWithdrawal = v.type === TransactionType.DEBIT;
                const prefix = `${i18nManager.getCurrencySign(v.currency_code)} ${isWithdrawal ? "-" : ""}`;
                return (<span style={isWithdrawal ? { color: "#FF7171", } : undefined}>{prefix}{StringHelper.toPresentableMoneyValue(v.amount)} ({prefix}{StringHelper.toPresentableMoneyValue(v.payable_amount)})</span>);
            }} />
            <Column className="table-c" header={labels.table.headers.platform_charge} template={(v: ITournamentTransaction) => {
                const isWithdrawal = v.type === TransactionType.DEBIT;
                return (<span style={isWithdrawal ? { color: "#FF7171", } : undefined}>{i18nManager.getCurrencySign(v.currency_code)} {isWithdrawal ? "-" : ""}{StringHelper.toPresentableMoneyValue(v.platform_amount)} ({v.extra_data?.platform_charge_percentage ?? 0} %)</span>);
            }} />
        </Table>
    </>);

    function fetchInformation() {
        setRecentTransactions({});
        tournamentService.queryTransactions(tournamentEdition.tournament.external_id, {
            size: 20,
            status__eq: TransactionStatus.COMPLETED,
        }).then(({ apiResponse }: SanitizedResponse<any>) => {
            if (searchParams.has("test")) {
                setRecentTransactions({ content: [] });
                return;
            }
            setRecentTransactions(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default RecentTransactions;
